import React from "react"
import { Modal, Button } from "react-bootstrap"

const ModalConfirmaVoto = props => {
	const { show, setShow, emitirVoto, loader } = props
	return (
		<Modal
			show={show}
			onHide={() => setShow(false)}
			backdrop="static"
			keyboard={false}
			className="text-center"
		>
			<Modal.Header closeButton>
				<Modal.Title>Confirmar Emisión de Voto</Modal.Title>
			</Modal.Header>
			<Modal.Body className="px-2 py-4">
				Está seguro que esta es su opción de voto?, si emite este sufragio no podrá cambiar su preferencia en el futuro,
				si es así, haga clic en "Emitir Voto", de lo contrario haga clic en "Volver a papeleta"
			</Modal.Body>
			<Modal.Footer>
				<Button disabled={loader} variant="success" block size="lg" onClick={emitirVoto}>
					Emitir Voto
				</Button>
				<Button
					variant="secondary"
					block
					disabled={loader}
					onClick={() => {
						setShow(false)
					}}
				>
					Volver a papeleta
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default ModalConfirmaVoto
